__turbopack_context__.v({
  "color": "ColorSelector-module-scss-module__czWdvW__color" + " " + "ColorSelector-module-scss-module__czWdvW__color-btn",
  "color-btn": "ColorSelector-module-scss-module__czWdvW__color-btn",
  "color-presets": "ColorSelector-module-scss-module__czWdvW__color-presets",
  "color-selector-container": "ColorSelector-module-scss-module__czWdvW__color-selector-container",
  "custom-color": "ColorSelector-module-scss-module__czWdvW__custom-color" + " " + "ColorSelector-module-scss-module__czWdvW__color-btn",
  "custom-color-upgrade-popover": "ColorSelector-module-scss-module__czWdvW__custom-color-upgrade-popover",
  "lock-icon": "ColorSelector-module-scss-module__czWdvW__lock-icon",
  "upgrade-popover-header": "ColorSelector-module-scss-module__czWdvW__upgrade-popover-header",
  "upgrade-popover-text": "ColorSelector-module-scss-module__czWdvW__upgrade-popover-text",
});
